/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import config from '@/const/config';
import { request } from '@/utils';
var switchApi = config.switchApi; // switchApi = 'https://easy-mock.com/mock/5d36a057e9bdf673070abd51/switchPower/getRentalRecord';
// switchApi = 'https://fat-switchpowerapi.hellobike.com/api';

/**
 * 添加租车记录 租车方
 * @param {Object} param body
 */

export function addRentalDepotRecord(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.rentalRecord.addRentalDepotRecord'
  }), {
    loginName: 'rentLogin'
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 添加租车记录 租车方
 * @param {Object} param body
 */

export function findRentalEmployees(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.rentalRecord.findRentalEmployees'
  }), {
    loginName: 'rentLogin'
  }).then(function (res) {
    return res.data;
  });
}
/**
 * 确认收车
 * @param {Object} param body
 */

export function rentalRecordConfirm(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchPower.promotion.rentalRecord.confirm'
  }), {
    loginName: 'rentLogin'
  });
}
/**
 * 获取租车列表
 * @param {Object} param body
 */

export function getRentalRecord(params) {
  return request.post(switchApi, _objectSpread({}, params, {
    action: 'switchpower.promotion.getRentalRecord'
  }), {
    loginName: 'rentLogin'
  });
}